import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, NavigationEnd, NavigationExtras, Router, ActivatedRoute, Params } from '@angular/router';
import { FormService } from './shared/services/form.service';
import { Global } from 'src/app/shared/global';
import { filter } from 'rxjs/operators';
import { Family } from './shared/models/family';
import { HttpParams } from '@angular/common/http';
import { GoogleTagManagerModule, GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('toggleClick', [
      state('true', style({
        marginRight: '0px'
      })),
      state('false', style({
        marginRight: '-250px'
      })),
      transition('true => false', animate('250ms linear')),
      transition('false => true', animate('250ms linear'))
    ])
  ]
})

export class AppComponent implements OnInit {
  title = 'HSABank';
  visible: boolean = false;
  activeRoute: string = '';
  family: Family;
  isNewLandingPage: boolean = false;
  isMedParentPage: boolean = false;


  constructor(private router: Router, private formService: FormService, private gtmService: GoogleTagManagerService, public global: Global, private route: ActivatedRoute) {
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.global.reSizeSliderContainer('');

      this.activeRoute = event['url'];
      this.global.activeRoute = event['url'];
      
      if (this.activeRoute.includes('/my-family') && this.formService.familyObjectForm.value.included 
      || this.activeRoute.includes('/pre-retirement-costs') && !this.formService.familyObjectForm.value.included
      || this.activeRoute.includes('/results')) {
        this.visible = true;
      }
      if (this.activeRoute.includes('/whats-next')) {
        this.visible = false;
      }

      //use browser to force links to pages
      //var serializableObj = { slug: "slug" };
      //window.history.pushState(serializableObj, 'test', this.activeRoute);
     /*  var window: any;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
      'event': 'virtualPageview',
      'pageUrl': this.activeRoute,
      'pageTitle': this.activeRoute //some arbitrary name for the page/state
      }); */

      //for testing and UAT purposes, lets remove GA and GTM from environments outside of production
      //toggle the isGoogleAnalyticsOn to true in the global.ts file before pushing to production envs
      if(this.global.isGoogleAnalyticsOn){
        const gtmTag = {
          event: 'page',
          pageName: this.activeRoute
        };
        this.gtmService.pushTag(gtmTag);
      }
    });

    // when someone click on back button
    router.events
    .subscribe((event: NavigationStart) => {
      console.log('this.activeRoute', this.activeRoute)
      if (this.activeRoute.includes('plan-for-year') || this.activeRoute.includes('health-insurance-covers') || this.activeRoute.includes('my-information') || this.activeRoute.includes('my-family') || this.activeRoute.includes('pre-retirement-costs')|| this.activeRoute.includes('retirement-costs')|| this.activeRoute.includes('hsa-information') || this.activeRoute.includes('hsa-investment') || this.activeRoute.includes('results') || this.activeRoute.includes('whats-next')) {
        this.isNewLandingPage = false;
        this.isMedParentPage = false;
      } else if (this.activeRoute.includes('/user-intro')) {
        this.isNewLandingPage = false;
        this.isMedParentPage = true;
      } else {
        this.isNewLandingPage = true;
      }
      if (event.navigationTrigger === 'popstate') {
        if (this.activeRoute.includes('/whats-next')) {
          this.visible = true;
        }
      }
      console.log('this.isNewLandingPage', this.isNewLandingPage)
    });
  }

  ngOnInit() {
    this.global.orgID = this.GetParam();
    // console.log("global org is:", this.global.orgID);
    const queryParams: Params = { org: this.global.orgID };

    this.router.navigate(
    [''], 
    {
      relativeTo: this.route,
      queryParams: queryParams, 
      queryParamsHandling: 'merge', // remove to replace all query params by provided
    });

    //this.router.navigate(['']);
  }

  GetParam(){
    //lets figure out the param situation here...
    if(window.location.href.includes("?")){
      var urlArray = window.location.href.split("?");
      return urlArray[1].split("=")[1];
    } else {
      return this.global.orgID;
    }
  }
}
